import {
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

const herokuPurple = '#79589F';
const herokuDarkPurple = '#430098';
const herokuNavy = '#1F1F33';

const pageTheme = genPageTheme({
  colors: [herokuDarkPurple, herokuPurple],
  shape: shapes.wave,
});

export const herokuTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: herokuPurple,
    },
    secondary: {
      main: herokuDarkPurple,
    },
    navigation: {
      background: herokuNavy,
      indicator: herokuPurple,
      color: '#D1D7E5',
      selectedColor: '#FFFFFF',
      navItem: {
        hoverBackground: '#2E2E4A',
      },
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: pageTheme,
    documentation: pageTheme,
    tool: pageTheme,
    service: pageTheme,
    website: pageTheme,
    library: pageTheme,
    other: pageTheme,
    app: pageTheme,
    apis: pageTheme,
  },
});
